import React from 'react';
import StaffCostsTableData from './StaffCostsTableData';
import satfflistService from '../../../services/elster/stafflist.service';
const notSavedStyle = {
  borderLeft: '5px solid red'
};
const StaffCostsRow = _ref => {
  let {
    rowData,
    data,
    setData,
    selectedProject,
    emptyRowId = null,
    removeEmptyRow,
    showHalfYearColumn,
    elsterYearForStaffCost
  } = _ref;
  const {
    body,
    saveData,
    deleteData,
    isSaved,
    setBody,
    setIsSaved
  } = satfflistService.useCrud(rowData, selectedProject, data, setData, removeEmptyRow, emptyRowId);
  return /*#__PURE__*/React.createElement("tr", {
    className: rowData.id ? '' : 'newRow'
  }, /*#__PURE__*/React.createElement(StaffCostsTableData, {
    body: body,
    rowData: rowData,
    setBody: setBody,
    isSaved: isSaved,
    setIsSaved: setIsSaved,
    saveData: saveData,
    deleteData: deleteData,
    notSavedStyle: notSavedStyle,
    data: data,
    emptyRowId: emptyRowId,
    removeEmptyRow: removeEmptyRow,
    showHalfYearColumn: showHalfYearColumn,
    elsterYearForStaffCost: elsterYearForStaffCost
  }));
};
export default StaffCostsRow;